import { render, staticRenderFns } from "./ClimbingPricesNew.vue?vue&type=template&id=753c690d&scoped=true&"
import script from "./ClimbingPricesNew.vue?vue&type=script&lang=js&"
export * from "./ClimbingPricesNew.vue?vue&type=script&lang=js&"
import style0 from "./ClimbingPricesNew.vue?vue&type=style&index=0&id=753c690d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753c690d",
  null
  
)

export default component.exports